import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule, MediaObserver } from '@ngbracket/ngx-layout';
import { Store } from '@ngxs/store';
import { ToggleSidenav } from 'src/shared/state/main.action';

@Component({
	selector: 'app-main-menu-button',
	templateUrl: './main-menu-button.component.html',
	styleUrls: ['./main-menu-button.component.scss'],
	imports: [
		FlexLayoutModule,
		MatButtonModule,
		MatIconModule,
		MatTooltipModule,
		RouterModule,
	],
})
export class MainMenuButtonComponent {
	private mediaObserver = inject(MediaObserver);
	private store = inject(Store);

	@Input()
	icon: string;
	@Input()
	text: string;
	@Input()
	link: any[] | string;
	@Input()
	showActiveLink: boolean = true;

	closeIfSmall(): void {
		if (this.mediaObserver.isActive('lt-md')) {
			this.store.dispatch([new ToggleSidenav()]);
		}
	}
}
